<template>
  <v-container fluid grid-list-sm>
    <v-card>
      <v-toolbar flat>
        <v-toolbar-title>
          <span class="font-weight-medium">
            {{ form.name || $t('COMPANIES.ITEM') }}
          </span>
        </v-toolbar-title>
        <v-spacer />
        <v-btn
          dark
          color="indigo"
          @click="
            editMode ? (editMode = false) : $router.push({ name: 'companies' })
          "
        >
          {{ $t('BUTTON.BACK') }}
        </v-btn>
        <v-btn
          v-if="!editMode"
          class="ml-2"
          color="primary"
          @click="editMode = true"
          >{{ $t('BUTTON.EDIT') }}</v-btn
        >
      </v-toolbar>
      <v-divider></v-divider>
    </v-card>
    <v-card class="mt-3" tile :loading="loading">
      <v-card-text>
        <company-edit
          v-model="form"
          :edit-mode="editMode"
          @cancel="editMode = false"
          @update="
            setData();
            editMode = false;
          "
        ></company-edit>
      </v-card-text>
    </v-card>
    <v-card class="mt-3" tile flat :loading="loading">
      <v-card-text class="pa-0">
        <contact-persons :id="id" :company="form" />
      </v-card-text>
    </v-card>
    <v-card class="mt-3" tile flat :loading="loading">
      <v-card-text class="pa-0">
        <company-orders-list :company-id="id" />
      </v-card-text>
    </v-card>
    <v-card class="mt-3" tile flat :loading="loading">
      <v-card-text class="pa-0">
        <company-invoices-list :company-id="id" />
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import CompanyEdit from '@/modules/companies/components/CompanyEdit';
import CompanyOrdersList from '../components/CompanyOrdersList';
import CompanyInvoicesList from '@/modules/companies/components/Invoices/CompanyInvoicesList';
import ContactPersons from '@/modules/contact_persons/components/ContactPersons';

export default {
  name: 'CompanyShowPage',
  components: {
    CompanyEdit,
    CompanyInvoicesList,
    ContactPersons,
    CompanyOrdersList
  },

  props: {
    id: {
      type: Number,
      required: true
    }
  },

  data: () => ({
    form: { upload: null },
    editMode: false
  }),

  computed: {
    ...mapGetters(['loading'])
  },

  created() {
    this.setData();
  },

  methods: {
    ...mapActions('company', ['retrieveCompany']),
    setData() {
      this.retrieveCompany(this.id).then(({ data }) => {
        this.form = data.data;
      });
    }
  }
};
</script>

<style scoped></style>
